module.exports = __webpack_public_path__ + "static/media/Napoli.4f669f1a.jpg";